import { useResponsive } from '../../../hooks/useResponsive';
import HowItWorksDesktop from './HowItWorksDesktop';
import HowItWorksMobile from './HowItWorksMobile';
import { useHowItWorks } from './useHowItWorks';

const HowItWorks = () => {
  const breakpointIndex = useResponsive([768]);
  const props = useHowItWorks();

  if (breakpointIndex === 0) {
    return <HowItWorksMobile {...props} />;
  }
  return <HowItWorksDesktop {...props} />;
};

export default HowItWorks;
